import React from 'react'
import offerdata from '../offerdata'
import OfferCard from '../UiComponents/OfferCard'

const Offer = () => {
    return (
        <div className="container-fluid service text-white" >
            <div className="container">
                <div className="row">
                    <div className=" mx-auto col-xs-12 col-sm-12 ">
                        <div className="my-5">
                            <h2 className=" text-center my-3 font-weight-bold">What We Offer</h2>
                            <h5 className=" text-center my-3 font-weight-bold ">Explore Our Courses for Job Readiness in the Industry</h5>
                        </div>
                        <div className="mt-3 my-4">
                            <div className="row">
                                <div className="col-sm-12 col-xs-12 mx-auto">
                                    <div className="row gy-3 gx-3">
                                        {offerdata.map((data, index) => {
                                            return (<OfferCard key={index} img={data.img} text={data.text} />)
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Offer
